import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * サイドメニュー画面の選択中のボタンを管理する。
 * 
 * @export
 * @class ButtonStateService
 */
@Injectable({
  providedIn: 'root'
})
export class ButtonStateService {

  /** 選択中のボタン */
  private selectedButtonId = new BehaviorSubject<string | null>(null);
  selectedButtonId$ = this.selectedButtonId.asObservable();
  
  /**
   * コンストラクタ
   * @memberof ButtonStateService
   */
  constructor() { }

  /**
   * 選択中のボタンIdを管理する。
   * 
   * @param id ボタンId
   * @memberof ButtonStateService
   */
  selectButton(id: string) {
    this.selectedButtonId.next(id);
  }

}
